import React from 'react';

import { pickBy, identity } from 'lodash';
import PropTypes from 'prop-types';

import { Form } from '~/components/Form';

import { Accord, Assist } from '..';

import * as S from './styles';

const GroupComponent = React.forwardRef((props, ref) => {
  const {
    taks,
    withoutGuides,
    toggleAccordion,
    onSubmitForm,
    initials,
    onSave,
    accordion,
  } = props;

  const formRef = React.useRef(null);

  // Save temp form
  const handleSaved = React.useCallback(() => {
    const form = pickBy(formRef.current.getData(), identity);
    onSave(form);
  }, []);

  // Save data when changing accordion.
  const handleChangeAccordion = React.useCallback((value) => {
    toggleAccordion(value);
  }, []);

  // Reset data
  const handleResetData = React.useCallback(() => {
    formRef.current.reset();
  }, []);

  // Submit form
  const submitForm = React.useCallback(() => {
    formRef.current.submitForm();
  }, []);

  // Set erros in form
  const setErrors = React.useCallback((erros) => {
    formRef.current.setErrors(erros);
  }, []);

  // Submit form
  const handleSubmit = React.useCallback((values) => {
    onSubmitForm(values);
  }, []);

  // Export functions
  React.useImperativeHandle(ref, () => ({
    handleResetData,
    submitForm,
    setErrors,
  }));

  return (
    <S.Wrapper ref={ref}>
      <Form ref={formRef} onSubmit={handleSubmit} initialData={initials}>
        <Accord
          tasks={taks}
          withoutGuides={withoutGuides}
          toggleAccordion={handleChangeAccordion}
          saveData={handleSaved}
          active={accordion}
        />
      </Form>

      {!withoutGuides && <Assist steps={taks} />}
    </S.Wrapper>
  );
});

GroupComponent.propTypes = {
  taks: PropTypes.arrayOf(PropTypes.any).isRequired,
  withoutGuides: PropTypes.bool.isRequired,
  toggleAccordion: PropTypes.func.isRequired,
  onSubmitForm: PropTypes.func.isRequired,
  initials: PropTypes.objectOf(PropTypes.any),
  onSave: PropTypes.func.isRequired,
  accordion: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]).isRequired,
};

GroupComponent.defaultProps = {
  initials: {},
};

export default GroupComponent;
